import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import ImmersiveLayout from '../components/ImmersiveLayout';
import { Sparkles } from 'lucide-react';

/**
 * /cart route is now a thin wrapper that auto-opens the global cart drawer.
 * Kept for backwards-compat with bookmarked URLs.
 */
export default function CartPage() {
  const { openCartDrawer } = useCart();
  const navigate = useNavigate();

  useEffect(() => {
    openCartDrawer();
  }, [openCartDrawer]);

  return (
    <ImmersiveLayout>
      <section className="min-h-[80vh] flex items-center justify-center px-6 py-24" data-testid="cart-page-stub">
        <div className="max-w-md text-center">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full glass-dark flex items-center justify-center">
            <Sparkles size={22} className="text-seikat-pink" strokeWidth={1.4} />
          </div>
          <p className="eyebrow-immersive">Keranjang</p>
          <h1 className="mt-3 font-heading text-4xl text-seikat-bone">Membuka <em>keranjang</em>…</h1>
          <p className="mt-4 font-body text-seikat-bone/60 text-sm">
            Geser dari kanan untuk melihat rangkaianmu.
          </p>
          <button
            onClick={() => navigate('/catalog')}
            className="btn-pill mt-8"
            data-testid="cart-stub-browse"
          >
            Jelajahi Bouquet
          </button>
        </div>
      </section>
    </ImmersiveLayout>
  );
}
